import { apiBffMobileV2Carts } from './api'

export const deleteProductInCart = async (cartId: string, productId: string): Promise<void> => {
  await apiBffMobileV2Carts.delete(`/${cartId}/products/${productId}`)
}
